/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type TimeRangeKind = (typeof TimeRangeKind)[keyof typeof TimeRangeKind];

export const TimeRangeKind = {
  custom: 'custom',
  today: 'today',
  yesterday: 'yesterday',
  '7_days': '7_days',
  '30_days': '30_days',
  this_month: 'this_month',
  this_quarter: 'this_quarter',
  '3_months': '3_months',
  '6_months': '6_months',
  '12_months': '12_months',
  q1: 'q1',
  q2: 'q2',
  q3: 'q3',
  q4: 'q4',
  ytd: 'ytd',
  this_year: 'this_year',
  last_month: 'last_month',
  last_quarter: 'last_quarter',
  '3_months_full': '3_months_full',
  '6_months_full': '6_months_full',
  '12_months_full': '12_months_full',
} as const;
